import { motion } from "framer-motion";
import { MessageCircle, Trophy, ArrowRight, Sparkles } from "lucide-react";
import { COMMERCIAL_WHATSAPP_DIGITS } from "@/constants/site";

const BEST_OFFER_MESSAGE =
  "Hola, tengo una propuesta de otra corredora para mi empresa y quiero que me la mejoren. Les envío mi póliza / cotización.";

const bestOfferWaUrl = `https://wa.me/${COMMERCIAL_WHATSAPP_DIGITS}?text=${encodeURIComponent(BEST_OFFER_MESSAGE)}`;

export const BestOffer = () => {
  return (
    <section id="mejor-oferta" className="relative scroll-mt-24 overflow-hidden bg-brand-ink py-14 text-white sm:scroll-mt-28 sm:py-20">
      {/* Fondos decorativos */}
      <div className="absolute -top-24 -left-10 h-72 w-72 rounded-full bg-brand-yellow/20 blur-3xl" />
      <div className="absolute -bottom-24 -right-10 h-72 w-72 rounded-full bg-brand-yellow/10 blur-3xl" />
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage:
          "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
        backgroundSize: "56px 56px",
      }} />

      <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <span
            data-testid="best-offer-badge"
            className="inline-flex items-center gap-2 rounded-full bg-brand-yellow px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-brand-ink shadow-lg shadow-brand-yellow/25"
          >
            <Trophy className="h-4 w-4" /> Especialistas en riesgos industriales
          </span>

          <h2
            data-testid="best-offer-title"
            className="font-display mt-6 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] tracking-tight"
          >
            Tenemos la <span className="text-brand-yellow">mejor cobertura</span> y{" "}
            <span className="text-brand-yellow">precio</span> del mercado.
          </h2>

          <p className="mx-auto mt-6 max-w-3xl text-base sm:text-lg lg:text-xl leading-relaxed text-white/85">
            ¿Tienes una propuesta mejor?{" "}
            <span className="font-semibold text-white">Envíanos tu póliza</span> y{" "}
            <span className="font-semibold text-brand-yellow">siempre te la mejoramos.</span>
          </p>

          <div className="mt-7 flex flex-col sm:mt-9 sm:flex-row items-center justify-center gap-3">
            <a
              href={bestOfferWaUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="best-offer-whatsapp-btn"
              className="group inline-flex h-12 w-full items-center justify-center gap-2.5 rounded-full bg-brand-whatsapp px-5 text-sm font-bold text-white shadow-xl shadow-brand-whatsapp/30 transition-all hover:-translate-y-0.5 hover:shadow-2xl sm:h-14 sm:w-auto sm:gap-3 sm:px-7 sm:text-base"
            >
              <MessageCircle className="h-5 w-5 shrink-0" />
              Envíanos tu póliza por WhatsApp
              <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="#cotizar"
              data-testid="best-offer-cotizar-btn"
              className="group inline-flex h-12 w-full items-center justify-center gap-2 rounded-full border-2 border-brand-yellow/70 bg-brand-yellow/10 px-5 text-sm font-bold text-brand-yellow transition-all hover:bg-brand-yellow hover:text-brand-ink sm:h-14 sm:w-auto sm:px-7 sm:text-base"
            >
              <Sparkles className="h-5 w-5 shrink-0" />
              Cotizar ahora
            </a>
          </div>

          <p className="mt-6 text-xs sm:text-sm text-white/60">
            Comparamos tu propuesta actual y te devolvemos la mejor oferta del mercado, sin costo.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
